<template>
  <div
    class="d-flex-column justify-start align-start gap-40"
    v-if="!$isMobile() && !$isTablet()"
  >
    <MmoPackDetail class="small_bg" />
  </div>
  <ServerPicker />
  <LevelPicker />
  <!-- <div
    class="d-flex-column justify-start align-start gap-24"
    v-if="!$isMobile() && !$isTablet()"
  >
    <template v-for="key in keys">
      <div
        class="pack_text_detail"
        v-html="getGamePack?.pack_description_detail[key]"
      ></div>
    </template>
  </div> -->
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import { onMounted } from "vue";
import MmoPackDetail from "./pickers/MmoPackDetail.vue";
import LevelPicker from "./pickers/LevelPicker.vue";

const { getGame, getGamePack } = useGameStore();
const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const account_sharing = getGamePack?.pack_options?.find(
    (op) => op.const_title === "account_sharing"
  );

  const extra_gold = getGamePack.pack_extra_options?.find(
    (op) => op.description === "gold_selector"
  );
  const standard = getGamePack?.pack_options?.find(
    (op) => op.const_title === "standard"
  );
  if (extra_gold) {
    checkoutStore.setPackExtraOptions({
      gold: extra_gold.id,
    });
  }
  if (standard) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, standard.id],
    });
  }
  if (account_sharing) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, account_sharing.id],
    });
  }
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentLevel: 1,
    desiredLevel: 80,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>

<style lang="scss">
@import "../../../assets/scss/fonts.scss";
.pack_text_detail {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 18px;
  section {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 18px;
    h1,
    h2 {
      @extend .font-family-2;
      @extend .bold-xxl;
      @extend .t-white;
    }
    p {
      @extend .font-family-2;
      @extend .regular-l;
      @extend .t-light;
    }

    ul {
      @extend .font-family-2;
      @extend .regular-l;
      @extend .t-light;
      padding-left: 16px;
      li {
        strong {
          font-weight: 400;
          color: var(--text-white);
        }
        a {
          display: inline;
          color: #973de5;
          span {
            color: #973de5 !important;
          }
        }

        &:not(:last-child) {
          margin-bottom: 3px;
        }
      }
    }
  }
}
</style>
